import React, { useState } from "react";
import Swal from "sweetalert2";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: ""
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    Swal.fire({
      icon: 'success',
      title: 'Success!',
      text: 'Message sent successfully! We will get back to you soon.',
      background: '#fff',
      color: '#333'
    });
    setFormData({ name: "", email: "", message: "" });
  };

  return (
    <div className="contact-section-new">
      <div className="container">
        <h2>Get In Touch</h2>
        <div className="contact-flex-container">
          <div className="contact-info-list">
            <div className="contact-info-item">
              <h3>Email</h3>
              <p>Info.prolongprofessional@gmail.com</p>
            </div>
            <div className="contact-info-item">
              <h3>Phone</h3>
              <p>+91 87809-33566</p>
            </div>
            <div className="contact-info-item">
              <h3>Address</h3>
              <p>
                A 1313 Titanium Business Park,<br />Near Makkarba Under Bridge
                Ahmedabad 380051
              </p>
            </div>
          </div>
          <div className="contact-form-container">
            <form className="contact-form-box" onSubmit={handleSubmit}>
              <input 
                type="text" 
                placeholder="Your Name" 
                required 
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
              />
              <input 
                type="email" 
                placeholder="Your Email" 
                required 
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
              />
              <textarea 
                placeholder="Your Message" 
                rows="5" 
                required 
                value={formData.message}
                onChange={(e) => setFormData({...formData, message: e.target.value})}
              ></textarea>
              <button type="submit">Send Message</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
